// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1LlXp","productName":"Table_productName__279Q4"};